// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__7a_LC","row":"ProcedureTreatmentSummary_row__26jSO"};